import gql from "graphql-tag";

const NEW_VOLUNTEERS_MUTATION = gql` 
  mutation NewVolunteers ($volunteerData: [NewVolunteerInput!]!, $chapterId: String!) {
    newVolunteers(volunteers: $volunteerData, chapterId: $chapterId) {
      id
      full_name
      email
      phone
      role
      roleStartDate
      roleEndDate
      street_address
      city
      state
      zip
    }  
  }
`;
export default NEW_VOLUNTEERS_MUTATION;